export default class CardService {
    static getPrice(card) {
        if (!card) {
            return 0;
        }

        let price = 0;

        if (!card.cardmarket) {
            // TCGTrader price
            if (!card.tcgplayer?.prices || !card.tcgplayer.prices[Object.keys(card.tcgplayer.prices)[0]]) {
                return 10;
            }

            let cardPriceKeys = Object.keys(card.tcgplayer.prices);

            // take mid-price of best card-tier;
            price = card.tcgplayer.prices[cardPriceKeys[cardPriceKeys.length - 1]].mid;
        } else {
            if (card.cardmarket && card.cardmarket.prices) {
                price = card.cardmarket.prices.avg7 ?? card.cardmarket.prices.avg30;
            } else {
                price = 1;
            }
        }

        // multiply by 10 to balance it out
        let calculatedPrice = Math.round(price ?? 0.5) * 10;
        return calculatedPrice > 0 ? calculatedPrice : 10;
    }

    static getCardImageUrl(card) {
        return '/assets/dipocaco/sets/'+(card.set?.id ?? card.set_id ?? card.id.split('-')[0])+'/cards/'+(card.card_id ?? card.id)+'.png';
    }

    static getSmallCardImageUrl(card) {
        return '/assets/dipocaco/sets/'+(card.set?.id ?? card.set_id ?? card.id.split('-')[0])+'/cards_sm/'+(card.card_id ?? card.id)+'.png';
    }

    static getSmallCardImageUrlByCardID(cardID) {
        return '/assets/dipocaco/sets/'+(cardID.split('-')[0])+'/cards_sm/'+cardID+'.png';
    }

    static getSetSymbolUrl(card) {
        return '/assets/dipocaco/sets/'+(card.set?.id ?? card.id.split('-')[0])+'/symbol.png';
    }

    static getSetSymbolUrlByCardID(cardID) {
        return '/assets/dipocaco/sets/'+(cardID.split('-')[0])+'/symbol.png';
    }

    static getSetLogoUrl(card) {
        return '/assets/dipocaco/sets/'+(card.set?.id ?? card.id.split('-')[0])+'/logo.png';
    }

    static getTypeIcon(type) {
        return '/assets/dipocaco/type-icons/'+type+'.png';
    }

    static getDexTypeIcon(type) {
        return '/assets/dipocaco/dex-type-icons/'+type+'.png';
    }

    static getCardRarityOrder() {
        return [
            "Unknown", "Common", "Uncommon", "Rare", "Rare EX", "Rare V", "Rare Prism Star", "Rare Prime",
            "Rare Holo", "Double Rare", "Rare Holo V", "Rare Holo VMAX", "Rare Holo Star",
            "Rare Holo VSTAR", "Rare Holo VStar", "Rare Holo EX", "Rare Holo GX", "Rare Holo LV.X", "Hyper Rare",
            "Ultra Rare", "Rare Ultra", "Amazing Rare", "Rare Rainbow", "Rare BREAK", "Radiant Rare", "Radiant Super Rare", "Rare Shiny", "Shiny Rare",
            "Rare Shiny GX", "Rare Shining", "Shiny Ultra Rare", "ACE SPEC Rare", "Rare ACE",
            "Rare Secret", "Illustration Rare", "Special Illustration Rare", "Trainer Gallery Rare Holo", "LEGEND", "Black and White Rare", "Promo"
        ];
    }

    static getSeriesReleaseOrder() {
        return [
            'Base', 'Gym', 'Neo', 'E-Card', 'EX', 'Diamond & Pearl', 'Platinum', 'HeartGold & SoulSilver', 'Black & White', 'XY', 'Sun & Moon', 'Sword & Shield', 'Scarlet & Violet', 'Trading Card Game Pocket', 'Mega Evolution',
        ];
    }

    static getRarityIcon(card) {
        let rarity = card.rarity?.toLowerCase();
        return this.getRarityIconByRarity(rarity);
    }

    static getRarityIconByRarity(rarity) {
        let fileName = '';

        switch (rarity) {
            default:
            case 'common':
                fileName = 'common';
                break;
            case 'uncommon':
                fileName = 'uncommon';
                break;
            case 'rare':
            case 'rare ex':
            case 'rare v':
            case 'rare prism star':
            case 'rare prime':
            case 'rare holo':
                fileName = 'rare';
                break;
            case 'rare holo v':
            case 'rare holo star':
            case 'rare holo vmax':
            case 'rare holo vstar':
                fileName = 'rare_rainboy';
                break;
            case 'double rare':
            case 'rare holo ex':
            case 'rare holo gx':
            case 'rare holo lv.x':
                fileName = 'double_rare';
                break;
            case 'hyper rare':
                fileName = 'hyper_rare';
                break;
            case 'ultra rare':
            case 'rare ultra':
                fileName = 'ultra_rare';
                break;
            case 'amazing rare':
            case 'rare rainbow':
                fileName = 'amazing_rare';
                break;
            case 'rare shiny':
            case 'shiny rare':
            case 'rare shiny gx':
            case 'rare shining':
                fileName = 'shiny';
                break;
            case 'shiny ultra rare':
                fileName = 'shiny_ultra_rare';
                break;
            case 'ace spec rare':
            case 'rare ace':
                fileName = 'ace_spec';
                break;
            case 'rare secret':
            case 'illustration rare':
            case 'special illustration rare':
            case 'trainer gallery rare holo':
                fileName = 'special_illustration_rare';
                break;
            case 'legend':
                fileName = 'legend';
                break;
        }

        return '/assets/dipocaco/rarity-icons/'+fileName+'.png';
    }

    static getCardTypes() {
        return [
            'Colorless',
            'Darkness',
            'Dragon',
            'Fairy',
            'Fighting',
            'Fire',
            'Grass',
            'Lightning',
            'Metal',
            'Psychic',
            'Water',
        ]
    }

    static sortCardsByRarity(cards) {
        return cards.sort((a, b) => this.getCardRarityOrder().indexOf(a.rarity) - this.getCardRarityOrder().indexOf(b.rarity));
    }

    static getRandomBoosterPackShotBySetId(setId) {
        return '/api/packshot/'+setId;
    }
}